/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RolesControllerFindAllQueryResponse, RolesControllerFindAllQueryParams, RolesControllerFindAll401, RolesControllerFindAll403 } from "../../models/rolesController/RolesControllerFindAll";

function getRolesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/roles` as const }  
  return res
}

/**
 * @summary Get available roles (built-ins + caller org custom roles)
 * {@link /api/v1/roles}
 */
export async function rolesControllerFindAll(params?: RolesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RolesControllerFindAllQueryResponse, ResponseErrorConfig<RolesControllerFindAll401 | RolesControllerFindAll403>, unknown>({ method : "GET", url : getRolesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}